export var IMAGE_FORMATS;
(function (IMAGE_FORMATS) {
  IMAGE_FORMATS[IMAGE_FORMATS["INITIAL"] = 0] = "INITIAL";
  IMAGE_FORMATS[IMAGE_FORMATS["SQUARE"] = 1] = "SQUARE";
  IMAGE_FORMATS[IMAGE_FORMATS["SMALL"] = 2] = "SMALL";
  IMAGE_FORMATS[IMAGE_FORMATS["MEDIUM"] = 3] = "MEDIUM";
  IMAGE_FORMATS[IMAGE_FORMATS["LARGE"] = 4] = "LARGE";
})(IMAGE_FORMATS || (IMAGE_FORMATS = {}));